import type { Words } from '@/i18n/types';

const fa: Words = {
  myCalls: 'تماس های من',
  waitingForExpertResponse: 'منتظر پاسخ کارشناس',
  departmentsPermissions: 'مجوزهای دپارتمان‌ها',
  affiliatesCommissionsSettlements: 'کمیسیون ها',
  affiliatesCommissionsSettlementsItems: 'آیتم های کمیسیون ها',
  lastExpert: 'آخرین کارشناس',
  visit: 'ویزیت',
  dashboard: 'داشبورد',
  advancedDashboard: 'داشبورد پیشرفته',
  layoutBuilder: 'سفارشی سازی',
  craft: 'ساخته شده',
  pages: 'صفحات',
  profile: 'پروفایل',
  profileOverview: 'مرور کلی',
  projects: 'پروژه‌ها',
  campaigns: 'کمپین‌ها',
  documents: 'اسناد',
  connections: 'ارتباطات',
  wizards: 'ویزاردها',
  horizontal: 'افقی',
  vertical: 'عمودی',
  fileManages: 'مدیریت فایل‌ها',
  folders: 'فولدرها',
  files: 'فایل‌ها',
  deleteFiles: 'حذف فایل‌ها',
  uploadFile: 'بارگذاری فایل',
  newFolder: 'فولدر جدید',
  choices: 'انتخاب',
  blank: 'صفحه خالی',
  addNewItemLabel: 'افزودن {name}',
  editItemLabel: 'ویرایش {name}',
  enterLabelField: '{name} را وارد کنید',
  selectField: 'انتخاب {name}',
  select: 'انتخاب',
  tickets: 'تیکت‌ها',
  myTickets: 'تیکت‌های من',
  chatwoot: 'چت آنلاین',
  chatwootInbox: 'صندوق ورودی',
  onlineChatBeta: 'چت آنلاین (آزمایشی)',  betaFeatures: 'قابلیت‌های آزمایشی',
  betaFeaturesPageHint: 'هر قابلیت را می‌توانید برای همه کاربران روشن کنید یا فقط برای چند کاربر مشخص. اگر برای همه روشن باشد، همچنان می‌توانید کاربرانی را از آن مستثنا کنید.',
  featureEnabledForEveryone: 'فعال برای همه کاربران',
  featureEnabledForEveryoneHint: 'وقتی روشن باشد، قابلیت برای همه کاربران فعلی و جدید فعال است؛ به‌جز کاربرانی که در فهرست غیرفعال‌ها قرار می‌دهید.',
  featureEnabledForActiveTermUsers: 'فعال برای کاربران دارای ترم فعال',
  featureEnabledForActiveTermUsersHint: 'وقتی روشن باشد، قابلیت برای هر کاربری که ترم فعال دارد فعال می‌شود، صرف‌نظر از وضعیت سوییچ «همه کاربران».',
  featureEnabledForLoggedInUsers: 'فعال برای کاربران وارد شده',
  featureEnabledForLoggedInUsersHint: 'وقتی روشن باشد، قابلیت برای هر کاربر واردشده‌ای فعال می‌شود، صرف‌نظر از وضعیت سوییچ «همه کاربران».',
  featureEnabledForLoggedOutUsers: 'فعال برای کاربران مهمان',
  featureEnabledForLoggedOutUsersHint: 'وقتی روشن باشد، قابلیت برای بازدیدکنندگانی که وارد نشده‌اند فعال می‌شود، صرف‌نظر از وضعیت سوییچ «همه کاربران».',
  featureUsersTitle: 'کاربران با تنظیم اختصاصی',
  featureManageUsers: 'مدیریت کاربران',
  featureUsersAllowHint: 'قابلیت به‌صورت پیش‌فرض خاموش است، پس فقط برای کاربرانی که در زیر «فعال» هستند روشن است.',
  featureUsersDenyHint: 'قابلیت برای همه روشن است، به‌جز کاربرانی که در زیر «غیرفعال» هستند.',
  featureUsersInactiveHint: 'کاربران کم‌رنگ، تنظیمی دارند که با وضعیت فعلی سوییچ بالا تفاوتی ایجاد نمی‌کند. اگر سوییچ را برگردانید دوباره اعمال می‌شود.',
  featureUserInactive: 'فعلاً اثری ندارد',
  featureAddUserDrawerTitle: 'افزودن کاربر با تنظیم اختصاصی',
  featureAddUserDrawerHint: 'مشخص کنید کاربر انتخاب‌شده، صرف‌نظر از سوییچ «همه کاربران»، «{feature}» را داشته باشد یا نه.',
  featureEnabled: 'فعال',
  featureDisabled: 'غیرفعال',
  ticketDepartments: 'دپارتمان‌ها',
  ticketDepartment: 'دپارتمان',
  departmentUsers: 'کاربران دپارتمان',
  requestDetails: 'جزییات درخواست',
  placeholderLabelEnterField: '{name} را وارد کنید',
  user: 'کاربر',
  name: 'نام',
  mobile: 'موبایل',
  subject: 'موضوع',
  priority: 'اولویت',
  low: 'کم',
  medium: 'متوسط',
  high: 'بالا',
  urgent: 'فوری',
  new: 'جدید',
  inProgress: 'در حال بررسی',
  waitingForUser: 'منتظر کاربر',
  closed: 'بسته شده',
  closedAt: 'تاریخ اتمام',
  mimeType: 'پسوند/فرمت',
  size: 'سایز',
  lastUpdate: 'آخرین بروزرسانی',
  description: 'توضیحات',
  status: 'وضعیت',
  active: 'فعال',
  inactive: 'غیرفعال',
  actions: 'عملیات',
  selectDate: 'انتخاب تاریخ',
  deleteSelectedFiles: 'آیا از حذف فایل‌های انتخاب شده مطمئن هستید؟',
  deleteSelectedFile: 'آیا از حذف این فایل مطمئن هستید؟',
  deleteSelectedItem: 'آیا از حذف این آیتم مطمئن هستید؟',
  deleteSelectedItems: 'آیا از حذف آیتم‌های انتخاب شده مطمئن هستید؟',
  yes: 'بله',
  no: 'خیر',
  search: 'جستجو',
  searchInLabel: 'جستجو در {name}',
  searchByMobileOrID: 'جستجو با موبایل یا شناسه',
  requestedByUser: 'کاربر درخواست‌دهنده',
  appliedByAdmin: 'ادمین رسیدگی‌کننده',
  statusDateType: 'نوع بازه وضعیت',
  createdAtRange: 'تاریخ ثبت',
  appliedAtRange: 'بازه تاریخ تایید',
  rejectedAtRange: 'بازه تاریخ رد',
  ComposeYourContent: 'محتوای خود را بنویسید...',
  dragAndDropFilesHelp: 'یا فایل ها را اینجا بکشید و رها کنید',
  tenant: 'سازمان',
  rolesPermissions: 'نقش‌ها و دسترسی‌ها',
  accessManagement: 'مدیریت دسترسی‌ها',
  changePassword: 'تغییر کلمه عبور',
  permissions: 'دسترسی‌ها',
  roles: 'نقش‌ها',
  foods: 'غذاهای وعده',
  food: 'غذا',
  foodItems: 'آیتم‌های غذایی',
  foodItem: 'آیتم غذایی',
  foodItemTitle: 'عنوان آیتم غذایی',
  foodItemType: 'نوع آیتم غذایی',
  addFoodItem: 'افزودن آیتم غذایی',
  editFoodItem: 'ویرایش آیتم غذایی',
  menuPeriod: 'مدت لیست',
  basicInformation: 'اطلاعات پایه',
  image: 'تصویر',
  nutritionalValue: 'ارزش غذایی',
  nutritionalInformation: 'اطلاعات تغذیه‌ای',
  unitConversion: 'تبدیل واحد',
  basicFoodItemInformation: 'جزییات آیتم غذایی',
  imageSelection: 'انتخاب تصویر',
  foodRelatedIllnesses: 'بیماری های مربوط به آیتم غذایی',
  unitConversionFromGrams: 'تبدیل واحد از گرم',
  unit: 'واحد',
  coefficientInGrams: 'ضریب به گرم',
  step: 'گام',
  nutritionalValuePerGram: 'ارزش غذایی در یک گرم',
  caloriesPerUnit: 'کالری در هر واحد',
  calories: 'کالری',
  totalCalories: 'مجموع کالری',
  carbohydrate: 'کربوهیدارت',
  fat: 'چربی',
  protein: 'پروتئین',
  good: 'خوب است',
  caution: 'توصیه نمی شود',
  avoid: 'اکیدأ توضیه نمی شود',
  dangerous: 'خطرناک است',
  diseaseName: 'نام بیماری',
  theConnectionBetweenFoodAndDisease: 'ارتباط غذا و بیماری',
  language: 'زبان',
  default: 'پیش فرض',
  preview: 'پیش نمایش',
  account: 'حساب کاربری',
  accountOverview: 'مرور حساب',
  settings: 'تنظیمات',
  authentication: 'احراز هویت',
  basicFlow: 'جریان اصلی',
  signIn: 'ورود',
  signUp: 'ثبت‌نام',
  passwordReset: 'بازیابی رمز عبور',
  forgotPassword: 'رمز عبور خود را فراموش کرده‌اید؟',
  multiStepSignUp: 'ثبت‌نام چند مرحله‌ای',
  error404: 'خطای ۴۰۴',
  error500: 'خطای ۵۰۰',
  apps: 'برنامه‌ها',
  chat: 'چت',
  privateChat: 'چت خصوصی',
  groupChat: 'چت گروهی',
  drawerChat: 'چت کشویی',
  widgets: 'ویجت‌ها',
  widgetsLists: 'لیست‌ها',
  widgetsStatistics: 'آمار',
  widgetsCharts: 'نمودارها',
  widgetsMixed: 'ترکیبی',
  widgetsTables: 'جداول',
  widgetsFeeds: 'فیدها',
  changelog: 'تغییرات',
  docsAndComponents: 'مستندات و کامپوننت‌ها',
  megaMenu: 'منوی مگا',
  exampleLink: 'لینک نمونه',
  modals: 'مودال‌ها',
  general: 'عمومی',
  inviteFriends: 'دعوت از دوستان',
  viewUsers: 'مشاهده کاربران',
  upgradePlan: 'ارتقا طرح',
  shareAndEarn: 'اشتراک‌گذاری و کسب درآمد',
  forms: 'فرم‌ها',
  newTarget: 'هدف جدید',
  newCard: 'کارت جدید',
  newAddress: 'آدرس جدید',
  createAPIKey: 'ایجاد کلید API',
  twoFactorAuth: 'احراز هویت دو مرحله‌ای',
  createApp: 'ایجاد برنامه',
  createAccount: 'ایجاد حساب کاربری',
  documentation: 'مستندات',
  components: 'کامپوننت‌ها',
  resources: 'منابع',
  activity: 'فعالیت',
  customers: 'مشتریان',
  gettingStarted: 'شروع به کار',
  customersListing: 'لیست مشتریان',
  customerDetails: 'جزئیات مشتری',
  calendarApp: 'تقویم',
  subscriptions: 'اشتراک‌ها',
  getStarted: 'شروع کنید',
  subscriptionList: 'لیست اشتراک‌ها',
  addSubscription: 'افزودن اشتراک',
  viewSubscription: 'مشاهده اشتراک',
  information: 'اطلاعات',
  email: 'ایمیل',
  emailVerifiedAt: 'زمان تایید ایمیل',
  phoneNumber: 'شماره موبایل',
  phoneVerifiedAt: 'زمان تایید شماره موبایل',
  colleagues: 'همکاران',
  list: 'لیست',
  items: 'آیتم‌ها',
  overview: 'نمای کلی',
  edit: 'ویرایش',
  details: 'جزییات',
  fullName: 'نام و نام خانوادگی',
  verified: 'تأیید شده',
  magazine: 'مجله',
  ProductPostSchedule: 'پست زمان بندی شده',
  dayNumber: 'روز',
  tags: 'برچسب ها',
  tag: 'برچسب',
  blogs: 'مقاله‌ها',
  blog: 'مقاله',
  addBlog: 'افزودن مقاله',
  editBlog: 'ویرایش مقاله',
  editDiet: 'ویرایش رژیم',
  addDiet: 'افزودن رژیم',
  categoryList: 'دسته‌بندی‌ها',
  draft: 'پیش نویس',
  published: 'منتشر شده',
  explanation: 'توضیح',
  foodList: 'لیست غذایی',
  meals: 'وعده ها',
  meal: 'وعده',
  fastingPattern: 'الگوی فستینگ',
  fastingPatternMeals: 'وعده های الگوهای فستینگ',
  fasting: 'فستینگ',
  islamicFasting: 'روزه اسلامی',
  title: 'عنوان',
  order: 'ترتیب',
  mealType: 'نوع وعده',
  diseases: 'بیماری ها',
  editMeal: 'ویرایش وعده',
  mealTitleIsRequired: 'عنوان وعده الزامی است.',
  mealTitle: 'عنوان وعده',
  mainMeal: 'وعده اصلی',
  snack: 'میان وعده',
  conditionalMeal: 'وعده شرطی',
  quotaMeal: 'وعده سهمیه',
  icon: 'آیکن',
  submit: 'ارسال',
  cancel: 'لغو',
  continue: 'ادامه',
  pleaseWait: 'لطفا صبر کنید...',
  back: 'بازگشت',
  mealTypeIsRequired: 'نوع وعده یک فیلد اجباری است',
  addMeal: 'افزودن وعده',
  enterMealTitle: 'عنوان وعده را وارد کنید',
  selectMealType: 'نوع وعده را انتخاب کنید',
  addNewRole: 'افزودن نقش جدید',
  roleDeletionMessage: 'آیا از حذف نقش {name} مطمئن هستید؟',
  choosingAccessLevels: 'انتخاب سطح های دسترسی',
  editPermissions: 'ویرایش دسترسی‌ها',
  addNewPermissions: 'افزودن دسترسی جدید',
  permissionDeletionMessage: 'آیا از حذف دسترسی {name} مطمئن هستید؟',
  close: 'بستن',
  save: 'ذخیره',
  sending: 'در حال ارسال...',
  roleEditing: 'ویرایش نقش',
  nameIsRequired: 'نام الزامی است.',
  selectingAtLeastOneAccessLevelIsRequired: 'انتخاب  حداقل یک سطح دسترسی الزامی است',
  formValidationErrorMessage: 'متاسفیم، به نظر می‌رسد خطاهایی شناسایی شده است، لطفاً دوباره امتحان کنید.',
  ok: 'تأیید',
  enterTheName: 'نام را وارد کنید',
  publishedAt: 'تاریخ و زمان انتشار',
  createdAt: 'تاریخ ثبت',
  updatedAt: 'تاریخ بروزرسانی',
  guardName: 'Guard name',
  tenantDeletionMessage: 'آیا مطمئنید که می‌خواهید مستاجر {name} را حذف کنید؟',
  domain: 'دامنه',
  domainIsRequired: 'دامنه الزامی است.',
  iconIsRequired: 'آیکن الزامی است.',
  enterTheDomain: 'دامنه را وارد کنید',
  enterTheIcon: 'آیکن را وارد کنید',
  addNewTenant: 'اضافه کردن tenant جدید',
  videos: 'ویدئوها',
  images: 'تصاویر',
  audios: 'صداها',
  upload: 'آپلود',
  selectFiles: 'انتخاب فایل‌ها',
  media: 'چندرسانه‌ای',
  fileManagement: 'مدیریت فایل',
  uploadToThisGroup: 'آپلود در این گروه:',
  category: 'دسته بندی',
  emptyTableMessage: 'موردی برای نمایش وجود ندارد.',
  deleteItems: 'حذف موارد',
  emptyTableText: 'داده‌ای یافت نشد',
  deleteSelectedMeal: 'آیا از حذف این وعده مطمئن هستید؟',
  selectIcon: 'انتخاب آیکن',
  noMoreOptions: 'گزینه بیشتری وجود ندارد...',
  loading: 'درحال بارگذاری',
  selectTitle: 'انتخاب {name}',
  dynamicLayouts: 'طرح‌های پویا',
  layouts: 'طرح‌‌ها',
  addLayout: 'افزودن طرح‌',
  slug: 'نامک',
  type: 'نوع',
  repeatable: 'تکرارپذیر',
  slugIsRequired: 'نامک الزامی است.',
  repeatableIsRequired: 'تکرارپذیر الزامی است.',
  layoutTypeIsRequired: 'نوع طرح الزامی است.',
  enterLayoutName: 'نام طرح را وارد کنید',
  enterLayoutSlug: 'نامک طرح را وارد کنید',
  process: 'فرآیند',
  page: 'صفحه',
  customDataHandler: 'کنترل‌کننده داده‌های سفارشی',
  enterHandlerName: 'نام کنترل‌کننده را وارد کنید',
  selectLayoutType: 'نوع طرح‌ را انتخاب کنید',
  deleteSelectedLayout: 'آیا از حذف این طرح مطمئن هستید؟',
  editLayout: 'ویرایش طرح',
  maxCountCharactersAllowed: 'حداکثر {count} کاراکتر مجاز است.',
  minCountCharactersAllowed: 'حداقل {count} کاراکتر مجاز است.',
  layoutType: 'نوع طرح',
  layoutName: 'نام طرح',
  layoutSlug: 'نامک طرح',
  validation: {
    required: '{field} یک فیلد اجباری است',
    numeric: '{field} باید یک مقدار عددی باشد',
    valid: 'لطفأ یک {field} معتبر وارد کنید.',
    leastCharacters: '{field} باید حداقل {min} کاراکتر داشته باشد',
    passwordsMustMatch: 'رمزهای عبور باید مطابقت داشته باشند',
    min: 'فیلد {field} باید حداقل {min} باشد.',
    max: 'فیلد {field} باید حداکثر {max} باشد.',
    totalPercentageMustBe100: 'درصد کل باید ۱۰۰ باشد',
    invalidIban: 'فرمت شماره شبا نامعتبر است.(**** **** **** **** **** ****)',
    invalidCardNumber: 'شماره کارت نامعتبر است.(16 رقم)'
  },
  createdSuccessfullyMessage: '{name} با موفقیت ایجاد شد.',
  updatedSuccessfullyMessage: '{name} با موفقیت بروزرسانی شد.',
  sections: 'سکشن‌ها',
  dynamicBuilder: 'صفحه ساز پویا',
  dynamicbuilder: 'صفحه ساز پویا',
  titleIsRequired: 'عنوان الزامی است.',
  descIsRequired: 'توضیحات الزامی است.',
  enterSectionTitle: 'عنوان بخش را وارد کنید',
  enterSectionDesc: 'توضیحات بخش را وارد کنید',
  addSection: 'افزودن بخش',
  editSection: 'ویرایش بخش',
  sectionTitle: 'عنوان بخش',
  definitions: 'تعاریف',
  addDisease: 'افزودن بیماری',
  editDisease: 'ویرایش بیماری',
  enterValidNumber: 'یک شماره معتبر وارد کنید.',
  enterValidEmail: 'یک ایمیل معتبر وارد کنید.',
  enterDiseaseTitle: 'عنوان بیماری را وارد کنید',
  enterDiseaseDesc: 'توضیحات بیماری را وارد کنید',
  enterDiseaseOrder: 'ترتیب بیماری را وارد کنید',
  thisFieldIsRequired: 'این فیلد الزامی است.',
  valueMustBeInteger: 'مقدار باید یک عدد صحیح باشد.',
  minNumberIs: 'حداقل مقدار {number} است.',
  maxNumberIs: 'حداکثر مقدار {number} است.',
  value: 'مقدار',
  enterCalorieValue: 'مقدار کالری را وارد کنید',
  countries: 'کشورها',
  enterCountryName: 'نام کشور را وارد کنید',
  countryName: 'نام کشور',
  callingCode: 'کد تماس',
  enterCountryCallingCode: 'کد تماس کشور را وارد کنید',
  code: 'کد',
  enterCountryCode: 'کد کشور را وارد کنید',
  addCountry: 'افزودن کشور',
  editCountry: 'ویرایش کشور',
  profileDetails: 'جزئیات پروفایل',
  editProfile: 'ویرایش پروفایل',
  avatar: 'آواتار',
  discard: 'دور انداختن',
  password: 'رمز عبور',
  signInMethod: 'روش ورود',
  resetPassword: 'بازنشانی رمز عبور',
  currentPassword: 'رمز عبور فعلی',
  newPassword: 'رمز عبور جدید',
  confirmNewPassword: 'تأیید رمز عبور جدید',
  updatePassword: 'به‌روزرسانی رمز عبور',
  yourChangesHaveBeenSavedSuccessFully: 'تغییرات شما با موفقیت ذخیره شد.',
  addColleague: 'افزودن همکار',
  enterColleagueName: 'نام همکار را وارد کنید',
  enterColleaguePassword: 'رمز عبور همکار را وارد کنید',
  enterUserName: 'نام کاربر را وارد کنید',
  enterUserPassword: 'رمز عبور کاربر را وارد کنید',
  users: 'کاربران',
  addUser: 'افزودن کاربر',
  editUser: 'ویرایش کاربر',
  ifNoChangeIsNeededLeaveBlank: 'اگر نیازی به تغییر نیست، خالی بگذارید',
  continueWithGoogle: 'ادامه با گوگل',
  continueWithFacebook: 'ادامه با فیسبوک',
  newAccount: 'حساب جدید؟',
  createAnAccount: 'ایجاد حساب کاربری',
  or: 'یا',
  enterCredentials: 'اطلاعات ورود خود را وارد کنید',
  enterYourMobile: 'شماره موبایل خود را وارد کنید.',
  enterOtp: 'کد تأیید',
  otp: 'کد یکبار مصرف',
  unexpectedErrorOccurred: 'خطای غیرمنتظره‌ای رخ داده است!',
  serverError: 'خطای سرور!',
  delete: 'حذف',
  operationWasSuccessful: 'عملیات موفقیت‌آمیز بود',
  personnel: 'همکار',
  personnels: 'همکاران',
  createPersonnel: 'افزودن همکار جدید',
  editPersonnel: 'ویرایش اطلاعات همکار',
  personnelProfile: 'پروفایل',
  settingsAndConfigs: 'تنظیمات و پیکربندی‌ها',
  appVersion: 'نسخه برنامه',
  android: 'Android',
  ios: 'iOS',
  web: 'Web',
  all: 'همه موارد',
  selectPlatform: 'پلتفرم را انتخاب کنید',
  platform: 'پلتفرم',
  version: 'نسخه',
  enterVersion: 'نسخه را وارد کنید',
  updateType: 'نوع بروزرسانی',
  changes: 'تغییرات',
  releasedAt: 'تاریخ انتشار',
  mandatory: 'اجباری',
  optional: 'اختیاری',
  addVersion: 'افزودن نسخه',
  forcedUpdate: 'به‌روزرسانی اجباری',
  enterChanges: 'تغییرات را وارد کنید',
  andNewField: 'افزودن فیلد جدید',
  enterValidValue: 'یک مقدار معتبر وارد کنید.',
  period: 'دوره',
  public: 'عمومی',
  foodMenus: 'لیست‌های غذایی',
  foodMenu: 'لیست‌ غذایی',
  calorieList: 'لیست کالری',
  editFoodMenu: 'ویرایش لیست غذایی',
  listOfCalorieRanges: 'لیست بازه های کالری',
  itCouldBeIslamicFasting: 'روزه‌ اسلامی',
  customerOrigins: 'ورودی‌های کاربر',
  customerOrigin: 'کانال ورودی',
  paymentGateways: 'درگاه‌های پرداخت',
  defaultPaymentGateway: 'درگاه پیش فرض',
  packages: 'پکیج‌ها',
  unsuccessfulPaymentLink: 'آدرس پرداخت ناموفق',
  successfulPaymentLink: 'آدرس پرداخت موفق',
  paymentRedirectUrls: 'آدرس‌های اینترنتی پرداخت',
  applyFilter: 'اعمال فیلتر',
  resetFilter: 'پاک کردن',
  startAndEndTime: 'زمان شروع و پایان',
  startTimeAt: 'زمان شروع',
  endTimeAt: 'زمان پایان',
  payments: 'پرداخت‌ها',
  paymentMethod: 'روش پرداخت',
  gateway: 'درگاه',
  cardToCard: 'کارت به کارت',
  discounts: 'تخفیف‌ها',
  maximumUse: 'حداکثر تعداد استفاده',
  frequencyOfUse: 'دفعات استفاده',
  fromDate: 'از تاریخ',
  toDate: 'تا تاریخ',
  percentage: 'درصد',
  fixed: 'ثابت',
  addDiscount: 'افزودن تخفیف',
  editDiscount: 'ویرایش تخفیف',
  discountType: 'نوع تخفیف',
  discountValue: 'میزان تخفیف',
  enterCode: 'کد را وارد کنید',
  selectDiscountType: 'نوع تخفیف را انتخاب کنید',
  enterDiscountValue: 'میزان تخفیف را وارد کنید',
  minimumPrice: 'حداقل قیمت',
  maximumPrice: 'حداکثر قیمت',
  enterMinimumPrice: 'حداقل قیمت را وارد کنید',
  enterMaximumPrice: 'حداکثر قیمت را وارد کنید',
  assignToUser: 'اختصاص به کاربر',
  activePeriod: 'دوره فعال',
  searchPhoneNumber: 'جستجوی شماره تلفن',
  addNewItem: 'افزودن مورد جدید',
  backToList: 'بازگشت به لیست',
  assignedUsers: 'کاربران اختصاص داده شده',
  orders: 'سفارشات',
  userId: 'شناسه کاربری',
  prices: 'قیمت‌ها',
  totalPrice: 'قیمت کل',
  discountAmount: 'مبلغ تخفیف',
  finalPrice: 'قیمت نهایی',
  pending: 'در حال بررسی',
  applied: 'اعمال شده',
  paid: 'پرداخت شده',
  approved: 'تایید شده',
  canceled: 'لغو شده',
  needsReview: 'نیاز به بررسی',
  shipped: 'ارسال شده',
  returned: 'مرجوع شده',
  assignTicket: 'اختصاص تیکت',
  maxCalory: 'حداکثر کالری',
  minCalory: 'حداقل کالری',
  range: 'بازه',
  day: 'روز',
  copy: 'کپی',
  timeFrame: 'بازه زمانی',
  mealName: 'نام وعده',
  mealCalories: 'کالری وعده',
  fastingMeal: 'غذای فستینگی',
  fastingCalories: 'کالری فستینگ',
  startAndEndPeriod: 'بازه شروع و پایان',
  sequence: 'ترتیب',
  fixedAmounts: 'مقادیر ثابت',
  fixedAmount: 'مقدار ثابت',
  enterMealInformation: 'اطلاعات غذای وعده را وارد کنید',
  foodMeal: 'غذای وعده',
  foodFasting: 'غذای فستینگی',
  duplicateRecordQuestion: 'آیا مطمئن هستید که می‌خواهید یک کپی از این رکورد ایجاد کنید؟',
  numbers: 'شماره‌ها',
  number: 'شماره',
  phone: 'تلفن',
  bankNumbers: 'بانک شماره‌ها',
  inputChannel: 'کانال ورودی',
  expert: 'کارشناس',
  experts: 'کارشناسان',
  createdBy: 'ایجاد شده توسط',
  resultLastCall: 'نتیجه آخرین تماس',
  numberCalls: 'تعداد تماس‌ها',
  utmCampaign: 'Campaign',
  utmMedium: 'Medium',
  utmSource: 'Source',
  utmContent: 'Content',
  registrationDate: 'تاریخ ثبت',
  channelUpdateDate: 'تاریخ بروزرسانی کانال',
  numberInformation: 'اطلاعات شماره',
  requestNumber: 'درخواست شماره',
  commandRequests: 'درخواست‌ها',
  calls: 'تماس‌ها',
  first: 'اول',
  second: 'دوم',
  third: 'سوم',
  fourth: 'چهارم',
  fifth: 'پنجم',
  sixth: 'ششم',
  seventh: 'هفتم',
  saturday: 'شنبه',
  sunday: 'یکشنبه',
  monday: 'دوشنبه',
  tuesday: 'سه‌شنبه',
  wednesday: 'چهارشنبه',
  thursday: 'پنجشنبه',
  friday: 'جمعه',
  preferredVisitWeekday: 'روز اعلام وزن',
  firstDay: 'روز اول',
  secondDay: 'روز دوم',
  thirdDay: 'روز سوم',
  fourthDay: 'روز چهارم',
  fifthDay: 'روز پنجم',
  sixthDay: 'روز ششم',
  seventhDay: 'روز هفتم',
  addFood: 'افزودن غذای وعده',
  editFood: 'ویرایش غذای وعده',
  foodDetails: 'جزییات غذا',
  diets: 'رژیم‌ها',
  dietType: 'نوع رژیم',
  foodTitle: 'عنوان غذا',
  coefficient: 'ضریب',
  foodItemNote: 'مجموع ضرایب آیتم های غذایی باید 100 باشد.',
  saveFoodCaloryConfirm: 'آیا از ذخیره این بازه کالری اطمینان دارید؟',
  recipe: 'دستور پخت',
  addCalorieRange: 'افزودن بازه کالری',
  intervalNumberError: 'بازه باید بین {min} و {max} باشد.',
  addRangeFrom: 'افزودن بازه از',
  toInfinity: 'تا بی نهایت',
  ratio: 'ضریب',
  forCaloriesFromRange: 'برای کالری از بازه ',
  till: 'تا',
  completeTheFoodDetailsFirstBeforeContinuing: 'قبل از ادامه ابتدا جزییات غذا را تکمیل نمایید.',
  leadDistributionRules: 'اولویت بندی لیدها',
  leadDistributionRule: 'اولویت بندی',
  sort: 'مرتب ‌سازی',
  distributionPercentage: 'درصد توزیع',
  olderThanMinutes: 'تا قبل از',
  newerThanMinutes: 'تا بعد از',
  newest: 'جدیدترین',
  oldest: 'قدیمی ترین',
  random: 'تصادفی',
  minute: 'دقیقه',
  hour: 'ساعت',
  timeInputCaption: 'فرمت: روز/ساعت/دقیقه',
  editMobileNumber: 'ویرایش شماره موبایل',
  loginToYourAccount: 'ورود به حساب کاربری',
  salesAssociateInformation: 'اطلاعات همکار فروش',
  salesAssociateReview: 'بررسی همکار فروش',
  paymentAccounts: 'درگاه‌های پرداخت',
  paymentAccount: 'درگاه پرداخت',
  cardNumber: 'شماره کارت',
  accountHolderName: 'نام صاحب حساب',
  mustBeExactlyNDigits: 'باید دقیقاً {digit} رقم باشد',
  identifier: 'Identifier',
  mobileNumber: 'شماره موبایل',
  behandam: 'به‌اندام',
  auth: 'اعتبارسنجی',
  categorization: 'دسته بندی',
  view: 'نمایش',
  create: 'ایجاد',
  update: 'ویرایش',
  request: 'درخواست',
  call: 'تماس',
  assign: 'اختصاص دادن',
  content: 'محتوا',
  dynamic_builder: 'سازنده پویا',
  payment: 'پرداخت',
  product: 'محصول',
  products: 'محصولات',
  editProduct: 'ویرایش محصول',
  createProduct: 'افزودن محصول',
  productTypes: 'انواع محصول',
  productType: 'نوع محصول',
  variantType: 'نوع پیکربندی',
  setting: 'تنظیمات',
  ticket: 'تیکت',
  translation: 'ترجمه',
  country: 'کشور',
  dynamic: 'پویا',
  static: 'ایستا',
  department: 'دپارتمان',
  attributes: 'ویژگی‌ها',
  attribute: 'ویژگی',
  attributeValue: 'مقدار ویژگی',
  assign_role: 'اختصاص دادن نقش',
  remove_role: 'حذف نقش',
  sync_roles: 'همگام سازی نقش',
  give_permission: 'اعطا مجوز',
  revoke_permission: 'لغو مجوز',
  sync_permissions: 'همگام سازی مجوز',
  role: 'نقش',
  permission: 'دسترسی',
  assignRole: 'اختصاص نقش',
  removeRole: 'حذف نقش',
  syncRoles: 'همگام‌سازی نقش‌ها',
  givePermission: 'اعطای مجوز',
  revokePermission: 'ابطال مجوز',
  syncPermissions: 'همگام‌سازی مجوزها',
  manage: 'مدیریت',
  leadDistribution: 'توزیع لید',
  lead: 'لید',
  affiliate: 'بازاریاب وابسته',
  returnRequests: 'درخواست‌های مرجوعی',
  returnRequest: 'درخواست مرجوعی',
  refund: 'بازپرداخت وجه',
  commissionRule: 'قوانین پورسانت',
  commissionRules: 'قوانین پورسانت',
  callTypes: 'انواع تماس',
  callPattern: 'الگوی تماس',
  supportCall: 'تماس پشتیبانی',
  viewAllCalls: 'مشاهده تمام تماس‌ها',
  note: 'یادداشت',
  affiliatePartner: 'همکار فروش',
  affiliatePartners: 'همکاران فروش',
  affiliateLink: 'لینک بازاریابی',
  affiliateLinks: 'لینک‌های بازاریابی',
  audit: 'حسابرسی',
  post: 'پست',
  layout: 'چیدمان',
  section: 'بخش',
  component: 'کامپوننت',
  componentType: 'نوع کامپوننت',
  discount: 'تخفیف',
  wallet: 'کیف پول',
  typeAttributes: 'ویژگی‌های نوع',
  release: 'انتشار',
  recentlySearched: 'جستجوهای اخیر',
  noResultFound: 'نتیجه‌ای یافت نشد!',
  calculateWeight: 'محاسبه وزن',
  gender: 'جنسیت',
  age: 'سن',
  weight: 'وزن',
  height: 'قد',
  wristCircumference: 'دور مچ',
  dailyActivity: 'فعالیت روزانه',
  calculation: 'محاسبه',
  addUnit: 'افزودن واحد',
  enterUnitName: 'نام واحد را وارد کنید',
  editUnit: 'ویرایش واحد',
  copiedSuccessfully: 'با موفقیت کپی شد',
  summary: 'خلاصه',
  readingTime: 'زمان خواندن',
  requestOtp: 'درخواست کد OTP',
  faqs: 'سوالات پرتکرار',
  addFaq: 'افزودن سوال پرتکرار',
  editFaq: 'ویرایش سوال پرتکرار',
  categories: 'دسته بندی ها',
  question: 'پرسش',
  link: 'لینک',
  answer: 'پاسخ',
  enterQuestion: 'پرسش را وارد کنید',
  enterAnswer: 'پاسخ را وارد کنید',
  amount: 'مبلغ',
  paidAt: 'تاریخ پرداخت',
  rejectedAt: 'تاریخ رد شدن',
  transactions: 'تراکنش ها',
  pendingTransactions: 'تراکنش‌های در انتظار بررسی',
  rejected: 'رد شده',
  notCanceledByUser: 'لغو نشده کاربر',
  canceledByUser: 'لغو شده کاربر',
  transactionMethod: 'روش پرداخت',
  wallets: 'کیف پول‌ها',
  balance: 'موجودی',
  blockBalance: 'موجودی بلوکه شده',
  currency: {
    name: 'نام ارز',
    symbol: 'نماد ارز',
    code: 'کد ارز',
    title: 'واحد'
  },
  key: 'کلید',
  meta: 'متا',
  uiType: 'نوع رابط کاربری',
  addComponent: 'افزودن کامپوننت',
  editComponent: 'ویرایش کامپوننت',
  parentComponent: 'کامپوننت پدر',
  parent: 'والد',
  enterName: 'نام را وارد کنید',
  enterKey: 'کلید را وارد کنید',
  enterValue: 'مقدار را وارد کنید',
  foodReplacementReport: 'گزارش غذای جایگزین',
  userType: 'نوع کاربر',
  event: 'رویداد',
  auditableType: 'نوع قابل حسابرسی',
  oldValues: 'مقادیر قدیمی',
  newValues: 'مقادیر جدید',
  ipAddress: 'آدرس IP',
  userAgent: 'عامل کاربر',
  reservedAt: 'تاریخ رزرو',
  suspendedAt: 'تاریخ تعلیق',
  finished: 'پایان یافته',
  unFinished: 'پایان نیافته',
  unmark: 'برگشت',
  cancelCompletion: 'لغو تکمیل',
  markAsUnfinished: 'تبدیل به پایان نیافته',
  markAsfinished: 'تبدیل به پایان یافته',
  refresh: 'بروزرسانی',
  noPermissionToUnmark: 'شما دسترسی به تغییر وضعیت پایان یافته را ندارید',
  group: 'گروه',
  callWasSuccessful: 'تماس با موفقیت انجام شد',
  theyCallThemselves: 'خودش تماس می گیرد',
  calledDidntAnswer: 'زنگ خورد پاسخ نداد',
  notAvailable: 'در دسترس نبودند',
  phoneWasOff: 'تلفن مخاطب خاموش بود',
  rejectedTheCall: 'رد تماس داد',
  theyAreBusy: 'اشغال بود',
  numberWasWrong: 'شماره اشتباه است',
  callLater: 'بعدا تماس بگیرید',
  audienceIsAbroad: 'مخاطب خارج از کشور است',
  lastStatus: 'آخرین وضعیت',
  confirmReleaseUserInfo: 'در صورت تایید، این کاربر از لیست تماس های نگهداشته شده حذف میشود و دیگر کارشناسان نیز میتوانند با این کاربر تماس بگیرند',
  confirmReleaseTicketsAssignment: 'در صورت تایید، تیکت‌های تخصیص داده شده به این همکار فروش آزاد شده و در دسترس سایر کارشناسان قرار می‌گیرد',
  releaseNewAssignments: 'آزادسازی رزروهای جدید',
  confirmReleaseNewAssignments: 'در صورت تایید، رزروهای جدید این همکار فروش آزاد شده و در دسترس سایر کارشناسان قرار می‌گیرد',
  userProfile: 'پروفایل کاربر',
  mealCompliance: 'رعایت رژیم',
  dietVideos: 'ویدیوهای روزانه',
  dietVideo: 'ویدیو رژیم',
  videoPost: 'پست ویدیویی',
  videoPosts: 'پست‌های ویدیویی',
  selectDiet: 'انتخاب رژیم',
  recalculateRemainingDays: 'محاسبه روزهای باقی‌مانده بر اساس ارزش',
  selectVideoPost: 'انتخاب پست ویدیویی',
  selectVideoPosts: 'انتخاب پست‌های ویدیویی',
  bulkAssociate: 'ارتباط دسته‌ای',
  bulkAssociateInfo: 'اطلاعات ارتباط دسته‌ای',
  bulkAssociateDescription: 'این عمل چندین پست ویدیویی را با رژیم انتخاب شده مرتبط می‌کند. شاخص ترتیب از شماره مشخص شده شروع شده و برای هر پست افزایش می‌یابد.',
  bulkAssociateSuccess: 'ویدیوها با موفقیت مرتبط شدند',
  associate: 'مرتبط کردن',
  startOrderIndex: 'شاخص شروع ترتیب',
  editDietVideo: 'ویرایش ویدیو رژیم',
  selectedVideos: 'ویدیوهای انتخاب شده',
  orderIndex: 'شاخص ترتیب',
  activate: 'فعال کردن',
  deactivate: 'غیرفعال کردن',
  contentCommunications: 'مدیریت محتوا و ارتباطات',
  salesFinance: 'فروش و مالی',
  supportTickets: 'پشتیبانی و تیکت‌ها',
  systemSettings: 'تنظیمات سیستم',
  nutritionHealth: 'برنامه‌های غذایی و سلامت',
  trainingSurveys: 'آموزش و نظرسنجی',
  activitiesReports: 'فعالیت‌ها و گزارشات',
  weightLoss: 'کاهش وزن',
  weightGain: 'افزایش وزن',
  stabilization: 'تثبیت',
  pregnancy: 'بارداری',
  registerPackage: 'ثبت نام',
  startTerm: 'شروع ترم',
  renewal: 'تمدید',
  getMenu: 'دریافت منو',
  financeHistory: 'سابقه مالی',
  viewUserFinancialHistory: 'نمایش سابقه مالی کاربر',
  digital: 'دیجیتال',
  physical: 'فیزیکی',
  service: 'سرویس',
  diet: 'رژیم',
  package: 'پکیج',
  deposit: 'واریز',
  withdraw: 'برداشت',
  block: 'مسدود',
  unblock: 'رفع انسداد',
  courseLength: 'طول دوره',
  remainingDays: 'تعداد روز باقی مانده',
  supportCallType: 'نوع تماس پشتیبانی',
  supportCallTypes: 'انواع تماس‌های پشتیبانی',
  supportCallPatterns: 'الگوهای تماس پشتیبانی',
  supportCallPattern: 'الگو تماس پشتیبانی',
  metadata: 'داده‌ها',
  isFree: 'رایگان است',
  hero: 'قهرمان رژیم',
  firstWeight: 'وزن ابتدایی',
  lastWeight: 'وزن نهایی',
  body: 'محتوا',
  views_count: 'تعداد بازدید',
  views: 'بازدیدها',
  rating: 'امتیاز',
  foodReplacement: 'جایگزینی غذا',
  paused: 'توقف',
  registerPackageMessageTermState: 'ثبت لیست غذایی نیازمند پکیج فعال میباشد',
  startTermMessageTermState: 'ثبت لیست غذایی نیازمند دوره فعال میباشد',
  renewalMessageTermState: 'ثبت لیست غذایی نیازمند تمدید دوره میباشد',
  getMenuMessageTermState: 'لیست غذایی دریافت نکرده',
  visitMessageTermState: 'برای ثبت لیست غذایی ابتدا مراجعه ایجاد کنید',
  underweight: 'کمبود وزن',
  normal: 'نرمال',
  obesityClass1: 'چاقی درجه ۱',
  overweight: 'اضافه وزن',
  obesitycClass2: 'چاقی درجه ۲',
  obesityClass3: 'چاقی درجه ۳',
  library: 'کتابخانه',
  upload_files: 'بارگذاری فایل‌ها',
  allocationSalesCollaboration: 'اختصاص همکاری در فروش (رزرو)',
  manual: 'دستی',
  show_wallet: 'نمایش کیف پول',
  increase_amount: 'افزایش موجودی',
  decrease_amount: 'کاهش موجودی',
  block_amount: 'بلوکه کردن',
  unblock_amount: 'آزاد سازی',
  toman: 'تومان',
  end_of_list: 'پایان لیست',
  typeMessage: 'پیغام ...',
  simple: 'ساده',
  configurable: 'پیکربندی پذیر',
  end: 'پایان',
  emailOrMobileRequired: 'ایمیل یا موبایل الزامی است',
  referenceTo: 'ارجاع به',
  userTickets: 'تیکت های کاربر',
  medicalDocument: 'مدرک پزشکی',
  heroes: 'قهرمانان',
  addhero: 'افزودن قهرمان رژیم',
  waitingList: 'لیست در انتظار',
  waiting: 'در انتظار',
  completed: 'تکمیل شده',
  allReturnRequests: 'همه درخواست های مرجوعی',
  onlineShoppingReturns: 'درخواست های مرجوعی خرید آنلاین',
  affiliatorReturns: 'درخواست های مرجوعی افیلیتور',
  reason: 'دلیل',
  employees: 'کارمندان',
  usersGenerateOtp: 'تولید OTP کاربران',
  salesPastYears: 'سال‌های قبل',
  usersLogin: 'ورود کاربران',
  usersRoles: 'نقش‌های کاربران',
  usersPermissions: 'مجوزهای کاربران',
  leads: 'لید‌ها',
  leadsRequestAssignment: 'درخواست تخصیص لید‌ها',
  leadsReleaseAssignments: 'آزادسازی لید‌ها',
  leadsCalls: 'تماس‌های لید‌ها',
  affiliatesAssignmentsActive: 'تخصیص‌های فعال همکاران',
  affiliatesAssignments: 'تخصیص‌های همکاران',
  affiliatesCommissionsRules: 'قوانین کمیسیون همکاران',
  affiliatesPartners: 'همکاران فروش',
  affiliatesPartner: 'همکار فروش',
  affiliatesPartnersExternal: 'همکاران فروش سازمانی',
  affiliatesLinks: 'لینک‌های همکاران',
  supportCallHistories: 'تاریخچه تماس‌های پشتیبانی',
  supportCalls: 'تماس‌های پشتیبانی',
  supportCallsRequestAssignment: 'درخواست تماس‌های پشتیبانی',
  supportCallsReleaseAssignments: 'آزادسازی تماس‌های پشتیبانی',
  supportCallReporting: 'گزارش تماس‌های پشتیبانی',
  notes: 'یادداشت‌ها',
  heroesImport: 'وارد کردن قهرمانان',
  audits: 'حسابرسی‌ها',
  terms: 'دوره‌ها',
  termsExpiration: 'انقضای دوره‌ها',
  termMenus: 'منوهای دوره',
  termMenusApprove: 'تأیید منوهای دوره',
  visits: 'بازدیدها',
  bodyMetrics: 'متریک‌های بدن',
  usersTerms: 'دوره‌های کاربران',
  usersTermsActive: 'دوره‌های فعال کاربران',
  usersVisitsActive: 'بازدیدهای فعال کاربران',
  usersMenusActive: 'منوهای فعال کاربران',
  usersDiet: 'رژیم غذایی کاربران',
  usersPendingCall: 'تماس‌های در انتظار کاربران',
  usersPregnancyWeek: 'هفته بارداری کاربران',
  pregnancyWeek: 'هفته بارداری',
  usersDiseases: 'بیماری‌های کاربران',
  stateSync: 'همگام‌سازی وضعیت',
  userStatsActiveTerm: 'آمار دوره فعال کاربران',
  userStatsWeight: 'آمار وزن کاربران',
  userStatsCalendar: 'تقویم آمار کاربران',
  options: 'گزینه‌ها',
  optionTypeDietGoal: 'هدف از گرفتن رژیم',
  optionTypeDietHistory: 'سابقه رژیم غذایی',
  optionTypeActivityLevel: 'میزان فعالیت روزانه',
  optionTypeSupportCallStatus: 'وضعیت تماس پشتیبانی',
  tagsTypes: 'انواع برچسب‌ها',
  categoriesSubCategories: 'زیردسته‌بندی‌ها',
  posts: 'پست‌ها',
  productPostSchedule: 'برنامه‌ریزی پست محصولات',
  componentTypes: 'انواع کامپوننت‌ها',
  layoutsComponents: 'کامپوننت‌های چیدمان',
  formsWithQuestions: 'فرم‌های دارای سوال',
  questions: 'سوالات',
  responses: 'پاسخ‌ها',
  comments: 'نظرات',
  fastingPatterns: 'الگوهای روزه‌داری',
  fastingPatternsMeals: 'وعده‌های الگوهای روزه‌داری',
  foodsCalory: 'کالری غذاها',
  foodsMeals: 'وعده‌های غذایی',
  foodsCalories: 'کالری‌های غذاها',
  foodsReplicateCalory: 'تکرار کالری غذاها',
  foodCalories: 'کالری غذا',
  foodCaloriesFoodItems: 'اقلام غذایی کالری غذا',
  foodItemsDiseases: 'بیماری‌های اقلام غذایی',
  foodItemsUnits: 'واحدهای اقلام غذایی',
  foodItemDiseases: 'بیماری‌های قلم غذایی',
  foodItemUnits: 'واحدهای قلم غذایی',
  mealsDiseases: 'بیماری‌های وعده‌های غذایی',
  menus: 'منوها',
  menusCalories: 'کالری منوها',
  menusReplicate: 'تکرار منوها',
  menuCalories: 'کالری منو',
  menuCaloriesReplicate: 'تکرار کالری منو',
  menuCaloryDays: 'روزهای کالری منو',
  menuCaloryDaysMeals: 'وعده‌های روزهای کالری منو',
  menuCaloryDayMeals: 'وعده‌های روز کالری منو',
  menuCaloryDayMealsFoods: 'غذاهای وعده‌های روز کالری منو',
  menuCaloryDayMealsOrder: 'ترتیب وعده‌های روز کالری منو',
  menuCaloryDayMealFoods: 'غذاهای وعده روز کالری منو',
  menuPeriods: 'دوره‌های منو',
  recommends: 'توصیه‌ها',
  units: 'واحدها',
  userMenus: 'منوهای کاربران',
  userMenusGenerate: 'تولید منوهای کاربران',
  userMenusWeeks: 'هفته‌های منوهای کاربران',
  userMenusMeals: 'وعده‌های منوهای کاربران',
  userMenuDays: 'روزهای منوی کاربر',
  userMenuDaysMeals: 'وعده‌های روزهای منوی کاربر',
  userMenuDayMeals: 'وعده‌های روز منوی کاربر',
  userMenuDayMealsFoods: 'غذاهای وعده‌های روز منوی کاربر',
  userMenuDayMealsOrder: 'ترتیب وعده‌های روز منوی کاربر',
  userMenuDayMealFoods: 'غذاهای وعده روز منوی کاربر',
  userMenuDayMealFoodsFoodItems: 'اقلام غذایی وعده روز منوی کاربر',
  mediaFolders: 'پوشه‌های رسانه',
  devices: 'دستگاه‌ها',
  notifications: 'اعلان‌ها',
  notificationsCategories: 'دسته‌بندی اعلان‌ها',
  ordersInvoice: 'فاکتورهای سفارشات',
  ordersSystemPackage: 'بسته‌های سیستمی سفارشات',
  ordersFastOrders: 'سفارشات سریع',
  returnRequestsOnline: 'درخواست‌های بازگشت آنلاین',
  returnRequestsAffiliate: 'درخواست‌های بازگشت همکاران',
  returnRequestsRefund: 'درخواست‌های بازپرداخت',
  walletsUser: 'کیف‌پول‌های کاربر',
  walletsDeposit: 'واریز به کیف‌پول',
  walletsWithdraw: 'برداشت از کیف‌پول',
  walletsBlock: 'مسدود کردن کیف‌پول',
  walletsUnblock: 'رفع مسدودی کیف‌پول',
  walletsTransactions: 'تراکنش‌های کیف‌پول',
  transactionLogs: 'تاریخچه تغییرات تراکنش',
  admin_id: 'کارشناس',
  rejected_at: 'تاریخ رد',
  gateway_ref_id: 'شماره ارجاع بانک',
  card_media_id: 'شناسه تصویر کارت',
  card_owner: 'نام صاحب کارت',
  card_number: 'شماره کارت',
  sheba_number: 'شماره شبا',
  tracking_code: 'شماره پیگیری',
  paid_at: 'تاریخ پرداخت',
  updated_at: 'تاریخ بروزرسانی',
  changesDetails: 'جزئیات تغییرات',
  viewTransactionLogs: 'نمایش تاریخچه تغییرات',
  walletsWithdrawalRequests: 'درخواست‌های برداشت کیف‌پول',
  userCards: 'کارت‌های کاربر',
  userCompanyCard: 'کارت شرکت -کاربر',
  productsForm: 'فرم محصولات',
  productsAttributesSearch: 'جستجوی ویژگی‌های محصولات',
  types: 'انواع',
  typesModels: 'مدل‌های انواع',
  typesAttributesReorder: 'بازچینش ویژگی‌های انواع',
  typesAttributes: 'ویژگی‌های انواع',
  ticketsParticipation: 'مشارکت در تیکت‌ها',
  ticketsStatus: 'وضعیت تیکت‌ها',
  ticketsCurrentStatusByDepartment: 'وضعیت کنونی تیکت‌ها بر اساس دپارتمان',
  supportCallsCurrentStatusByType: 'وضعیت کنونی تماس‌های پشتیبانی بر اساس نوع',
  salePanel: 'پنل فروش',
  salesDaily: 'فروش روزانه',
  salesTotal: 'کل فروش',
  salesProducts: 'فروش محصولات',
  salesReturned: 'فروش مرجوعی',
  salesAffiliate: 'فروش همکاران',
  salesSales: 'فروش‌های فروش',
  salesRegistrations: 'ثبت‌نام‌های فروش',
  salesRenewals: 'تمدیدهای فروش',
  salesTopCustomerOrigins: 'منابع برتر مشتریان فروش',
  leadsCount: 'تعداد لید‌ها',
  callsTotal: 'کل تماس‌ها',
  releases: 'آزادسازی‌ها',
  tenants: 'اجاره‌کنندگان',
  tenantsConfigs: 'پیکربندی اجاره‌کنندگان',
  departmentsUsers: 'کاربران دپارتمان‌ها',
  departments: 'دپارتمان‌ها',
  ticketsActivityLogs: 'لاگ‌های فعالیت تیکت‌ها',
  ticketsRequestAssignment: 'درخواست تخصیص تیکت‌ها',
  ticketsReleaseAssignment: 'آزادسازی تخصیص تیکت‌ها',
  ticketsMessages: 'پیام‌های تیکت‌ها',
  usersMyPermissions: 'مجوزهای من',
  usersBlocks: 'مسدودی‌های کاربران',
  usersSearch: 'جستجوی کاربران',
  usersDeletedAccount: 'حساب‌های حذف‌شده کاربران',
  medicalDocuments: 'اسناد پزشکی',
  addresses: 'آدرس‌ها',
  notification: 'اعلان‌ها',
  feedback: 'بازخورد',
  report: 'گزارش',
  percent: 'درصد',
  rules: 'قوانین',
  target: 'هدف',
  targetType: 'نوع هدف',
  targetId: 'شناسه هدف',
  affectedUser: 'کاربر هدف',
  requestedBy: 'درخواست‌دهنده',
  appliedBy: 'بررسی‌کننده',
  appliedAt: 'تاریخ بررسی',
  reviewNote: 'یادداشت بررسی کننده',
  entityType: 'نوع موجودیت',
  entity: 'موجودیت',
  extraCommission: 'کمیسیون مازاد',
  commission: 'کمیسیون',
  commissionType: 'نوع پورسانت',
  redirectUrl: 'لینک بازگشت',
  clickCount: 'تعداد کلیک',
  affiliatableType: 'نوع همکار',
  uniqueIdentifier: 'شناسه یکتا',
  discountCode: 'کد تخفیف',
  registrationsChart: 'نمودار ثبت نامی ها',
  renewalsChart: 'نمودار تمدیدی ها',
  paymentsChart: 'نمودار پرداخت ها',
  expertsCallsReport: 'گزارش تماس کارشناسان',
  callReports: 'گزارش تماس‌ها',
  reports: 'گزارشات',
  requestedNumbersReport: 'گزارش شماره‌های درخواستی',
  numbersStatusReport: 'گزارش وضعیت شماره‌ها',
  requestedNumbersReportByInputChannel: 'گزارش شماره‌های درخواستی به تفکیک کانال ورودی',
  affiliateSalesReport: 'گزارش فروش افیلیت',
  affiliateSalesReportDetails: 'جزئیات گزارش فروش افیلیت',
  affiliateSalesReportExternal: 'گزارش فروش افیلیت سازمانی',
  affiliateAssignments: 'لیست افیلیت ها',
  searchByMobileOrName: 'جستجو با آیدی، موبایل یا نام',
  hasPaidOrder: 'پرداخت موفق',
  totalSalesReport: 'گزارش فروش کل',
  dailySalesReport: 'گزارش فروش به تفکیک روز',
  totalSalesReportByPackage: 'گزارش فروش کل به تفکیک پکیج',
  totalPackageReturnsReport: 'گزارش فروش کل مرجوعی پکیج',
  inputChannelsReport: 'گزارش کانال‌های ورودی',
  ticketParticipationReport: 'گزارش مشارکت در تیکت',
  ticketsStatusReport: 'گزارش وضعیت تیکت‌ها',
  affiliatableName: 'نام همکار فروش',
  confirmedCommission: 'مبلغ کمیسیون‌ تأیید شده',
  confirmedSale: 'مبلغ فروش تأیید شده',
  confirmedSalesCount: 'تعداد فروش‌ تأیید شده',
  unconfirmedSalesCount: 'تعداد فروش‌ تأیید نشده',
  conversionRate: 'نرخ تبدیل',
  nonPurchasersCount: 'تعداد غیر خریداران ',
  payableCommission: 'کمیسیون قابل پرداخت',
  unconfirmedCommission: 'مبلغ کمیسیون‌ تأیید نشده',
  unconfirmedSale: 'مبلغ فروش‌ تأیید نشده',
  returnCommission: 'کمیسیون مرجوعی',
  returnedSalesCount: 'فروش‌های مرجوعی',
  total: 'مجموع',
  inboundCount: 'تعداد تماس‌های ورودی',
  outboundCount: 'تعداد تماس‌های خروجی',
  lineChart: 'نمودار خطی',
  barChart: 'نمودار میله‌ای',
  pieChart: 'نمودار دایره‌ای',
  bubbleChart: 'نمودار حبابی',
  table: 'جدول',
  count: 'تعداد',
  totalCalls: 'کل تماس‌ها',
  saleCount: 'فروش کل',
  themeMode: 'حالت روشنایی',
  light: 'روشن',
  dark: 'تاریک',
  rtlMode: 'راست چین',
  rtl: 'راست چین',
  widthMode: 'عرض صفحه',
  fluid: 'تمام عرض',
  iconStyle: 'نوع آیکن‌ها',
  sidebarMenuIcon: 'نوع آیکن‌های سایدبار',
  Layouts: 'لایه‌ها',
  reset: 'ریست',
  lightSidebar: 'روشن',
  darkSidebar: 'تاریک',
  signOut: 'خروج',
  myProfile: 'حساب کاربری من',
  associateSalesReport: 'گزارش فروش همکاران',
  distributionType: 'نوع توزیع',
  distributionPriority: 'اولویت توزیع',
  duration: 'مدت لیست (روز)',
  multiplePregnancy: 'بارداری_چندقلویی',
  diabetes: 'دیابت',
  lactation: 'شیردهی',
  usual: 'عمومی ',
  special: 'شرایط خاص',
  blocker: 'بلاکی',
  otherInformation: 'سایر اطلاعات',
  assignedAt: 'تاریخ تخصیص',
  customerOriginUpdatedAt: 'تاریخ بروزرسانی کانال',
  availableAt: 'موجود تا تاریخ',
  birthdate: 'تاریخ تولد',
  male: 'آقا',
  female: 'خانم',
  commonGender: 'هر دو',
  orderCode: 'کد سفارش',
  startsAt: 'تاریخ شروع',
  expiresAt: 'تاریخ پایان',
  author: 'نویسنده',
  mostViewed: 'پربازدیدترین',
  mostWeightLoss: 'بیشترین کاهش وزن',
  mostWeightGain: 'بیشترین افزایش وزن',
  affectingUserDisease: 'مؤثر بر بیماری کاربر',
  subcategories: 'زیردسته ها',
  activeAccounts: 'حساب‌های فعال',
  abbreviation: 'مخفف نام بیماری',
  subdiseases: 'بیماری‌های زیرمجموعه',
  bankCard: 'کارت بانکی',
  startDate: 'تاریخ شروع',
  endDate: 'تاریخ پایان',
  created: 'ایجاد شده',
  updated: 'ویرایش شده',
  deleted: 'حذف شده',
  activities: 'فعالیت ها',
  releaseAssignment: 'آزاد سازی',
  output: 'خروجی',
  fileName: 'نام فایل',
  getOutput: 'دریافت خروجی',
  id: 'شناسه',
  oldId: 'شناسه قدیم',
  columnHeaders: 'ستون‌های جدول',
  excelOutput: 'خروجی اکسل',
  importExcel: 'وارد کردن اکسل',
  file: 'فایل',
  conversationTopics: 'موضوعات تماس',
  smsTemplates: 'قالب‌های پیامک',
  smsTemplate: 'قالب پیامک',
  addSmsTemplate: 'افزودن قالب پیامک',
  editSmsTemplate: 'ویرایش قالب پیامک',
  driver: 'درایور',
  selectDriver: 'انتخاب درایور',
  templateId: 'شناسه قالب',
  enterTemplateId: 'شناسه قالب را وارد کنید',
  enterLabel: 'برچسب را وارد کنید',
  sampleText: 'متن نمونه',
  enterSampleText: 'متن نمونه را وارد کنید',
  isPlain: 'متن ساده',
  isPublic: 'عمومی',
  tokens: 'توکن‌ها',
  tokenName: 'نام توکن',
  tokenValue: 'مقدار توکن',
  addToken: 'افزودن توکن',
  tokensHelperTitle: 'راهنمای توکن‌ها',
  tokensHelperText: 'نام توکن (کلید) به سرویس پیامک ارسال می‌شود و مقدار توکن برای پر کردن خودکار در پنل ادمین استفاده می‌شود. مقادیر پشتیبانی شده: name (نام کاربر)، admin (نام ادمین)، adminPhone (شماره ادمین)',
  sampleTextHelper: 'متغیرها باید با علامت % شروع شوند. مثال: %TOKEN، %token10، %NAME',
  plain: 'متن ساده',
  item: 'مورد',
  callHistory: 'تاریخچه تماس',
  isCommissionCanceller: 'لغوکننده کمیسیون',
  withdrawalRequests: 'درخواست های برداشت وجه',
  withdrawalRequest: 'درخواست برداشت وجه',
  unassigned: 'قابل تخصیص',
  uncompleted: 'ناتمام',
  waitingReply: 'منتظر پاسخ',
  successfulCalls: 'تماس‌های موفق',
  successPercentage: 'درصد موفقیت',
  callcenter: 'مرکز تماس',
  extensions: 'افزونه‌ها',
  referral: 'لینک دعوت',
  admins: 'همکاران',
  supervisor: 'سوپروایزر',
  affiliates: 'بازاریابی',
  supportConversationTopics: 'مباحث مکالمه پشتیبانی',
  supportCallHistoriesTopics: 'تاریخچه تماس‌ها',
  leadsImport: 'وارد کردن شماره‌ها از طریق excel',
  taggables: 'تخصیص تگ‌ها',
  specialCondition: 'شرایط خاص',
  mealsOrder: 'مرتب سازی وعده‌ها',
  leadsCallsStats: 'آمار تماس‌ها',
  leadsCallsByAdmin: 'تماس های کارشناس',
  leadsCallsByStatus: 'تماس‌ها بر اساس وضعیت',
  leadsCallsByDate: 'تماس‌ها براساس وضعیت',
  sales: 'فروش‌',
  supportCallsStats: 'آمار تماس‌های پشتیبانی',
  ticketsReleaseAssignments: 'آزادسازی تکیت‌ها',
  callsMakeCall: 'ایجاد تماس',
  callsCheckNew: 'بررسی تماس‌های جدید',
  queues: 'صف‌ها',
  queueMembers: 'افراد در صف',
  gamification: 'بازی سازی',
  badges: 'نشان‌ها',
  date: 'تاریخ',
  commissions: 'کمیسیون‌ها',
  commissionSettlement: 'تسویه حساب کمیسیون',
  recalculateCommission: 'محاسبه مجدد کمیسیون',
  orderPaymentDate: 'تاریخ پرداخت سفارش',
  confirmRecalculateCommission: 'کمیسیون این سفارش بر اساس آخرین قانون کمیسیون، مجدداً محاسبه می‌شود. آیا اطمینان دارید؟',
  deductedAmount: 'مبلغ کسر شده',
  amountType: 'نوع تخفیف',
  iban: 'شماره شبا',
  userCard: 'کارت کاربر',
  checkNetworkConnection: 'لطفاً اتصالتون به اینترنت رو بررسی و دوباره تلاش کنید.',
  tryAgain: 'تلاش مجدد',
  flowManagement: 'مدیریت فلو',
  flow: 'فلو',
  flowConstruction: 'ساخت فلو',
  notStarted: 'شروع نشده',
  usersBankCards: 'کارت‌های بانکی کاربران',
  cardholderName: 'نام صاحب کارت',
  noResultsFound: 'موردی یافت نشد.',
  obesity_class_1: 'اضافه وزن',
  obesity_class_2: 'چاقی درجه ۲',
  obesity_class_3: 'چاقی درجه ۳',
  menu: 'منو',
  support: 'پشتیبانی',
  calorieRange: 'بازه کالری',
  calorieInfoChangeUpdateFoodList: 'با تغییر اطلاعات، کالری دریافتی تغییر و در نتیجه لیست غذایی تغییر می‌کند؛ پیشنهاد می‌شود لیست غذایی بروزرسانی شود.',
  addConfig: 'افزودن کانفیگ جدید',
  hasTicket: 'ارسال تیکت',
  filter: 'فیلتر',
  clear: 'پاک کردن',
  nextMenuDate: 'تاریخ منوی بعدی',
  pregnancyStartDate: 'تاریخ شروع بارداری',
  processSlug: 'عنوان فرآیند',
  processData: 'مقدار فرآیند',
  paymentNumber: 'شماره پرداخت',
  trackingCode: 'کد پیگیری',
  bankReferenceNumber: 'شماره ارجاع بانک',
  paymentType: 'نوع پرداخت',
  paymentDate: 'تاریخ پرداخت',
  clearAndClose: 'پاک کردن و بستن',
  orderDate: 'تاریخ سفارش',
  shopping: 'خرید',
  systemic: 'سیستمی',
  financialOperations: 'عملیات مالی',
  awaitingSplit: 'در انتظار تقسیم',
  awaitingReferralSplit: 'در انتظار تقسیم ریفرال',
  returnDeadline: 'پایان مهلت مرجوع',
  signupDate: 'تاریخ ثبت‌نام',
  randomStringLength: 'طول رشته تصادفی',
  prefix: 'پیشوند',
  suffix: 'پسوند',
  couponPrefix: 'پیشوند (فقط حروف لاتین و اعداد)',
  couponSuffix: 'پسوند (فقط حروف لاتین و اعداد)',
  onlyFirstBy: 'برای اولین خرید',
  filtering: 'فیلتر کردن',
  unfinished: 'جاری',
  convinced: 'متقاعد شده',
  notConvinced: 'متقاعد نشده',
  newVersionAvailable: 'بروزرسانی جدید در دسترس است',
  reloadPage: 'بارگذاری مجدد صفحه',
  activeTimeFrame: 'بازه زمانی فعال',
  firstOrderOnly: 'برای اولین خرید',
  assignToProduct: 'اختصاص به محصول',
  message: 'پیغام',
  callResult: 'نتیجه تماس',
  callStatus: 'وضعیت تماس',
  purchaseProbability: 'احتمال خرید',
  priceStatus: 'وضعیت براساس قیمت',
  noProblem: 'مشکلی نداشت',
  discountOrInstallment: 'اقساطی یا با تخفیف میخواد',
  wantsFree: 'مفت میخواد',
  purchased: 'خرید کرد',
  noPlan: 'برنامه نمیخواد',
  noAnswer: 'عدم پاسخگویی',
  callAgain: 'تماس مجدد',
  needFreeConsult: 'نیازمند مشاوره رایگان',
  ableToBuy: 'امکان خرید دارد',
  reservedByOther: 'رزرو شده توسط کارشناس دیگر',
  userHungUp: 'کاربر تماس را قطع کرد',
  notAwareOfCall: 'در جریان درخواست تماس نبود',
  hasDiet: 'رژیم دارد',
  callSuccessful: 'تماس با موفقیت انجام شد',
  phoneOff: 'تلفن مخاطب خاموش بود',
  unavailable: 'در دسترس نبود',
  rangNoAnswer: 'زنگ خورد پاسخ نداد',
  busy: 'اشغال بود',
  wrongNumber: 'شماره اشتباه بود',
  willCallBack: 'خودش تماس میگیره',
  international: 'مخاطب خارج از کشور است',
  processed: 'پردازش شده',
  salesReport: 'گزارش فروش',
  address: 'آدرس',
  postalcode: 'کد پستی',
  province: 'استان',
  city: 'شهر',
  calory: 'کالری',
  card: 'کارت',
  admin: 'کارشناس',
  daysAfterStart: 'روز پس از شروع',
  myNumbers: 'شماره های من',
  referenceCount: 'تعداد یک مرجع',
  soldCount: 'تعداد یک فروش رفته',
  referenceAmount: 'مبلغ مرجعی',
  totalGrossSales: 'کل مبلغ فروش - ناخالص',
  salesProductsReport: 'گزارش فروش محصولات',
  countUnit: 'عدد',
  totalNetSales: 'کل فروش خالص',
  returnAmount: 'مبلغ مرجوعی',
  totalDiscounts: 'مجموع تخفیف‌ها',
  netSales: 'فروش خالص',
  totalSalesCount: 'تعداد کل فروش',
  averagePrice: 'قیمت متوسط',
  totalSalesLabel: 'فروش کل',
  totalCountLabel: 'تعداد کل',
  returnedCountLabel: 'تعداد مرجوعی',
  returnAmountLabel: 'مبلغ مرجوعی',
  finalIncomeLabel: 'درآمد نهایی',
  shop: 'فروشگاه',
  currentInventory: 'موجودی فعلی از نگاه ها و کانت به کانت ها',
  parsianGateway: 'درگاه پارسیان',
  samanGateway: 'درگاه سامان',
  mellatGateway: 'درگاه ملت',
  zarinpalGateway: 'درگاه زرین پال',
  snapPay: 'اسنپ پی',
  latestIssues: 'آخرین شماره‌ها',
  lastCallDate: 'تاریخ آخرین تماس',
  noReportsToDisplay: 'تو بازه انتخابی گزارشی برای نمایش وجود ندارد.',
  dedicated: 'اختصاص یافته',
  withoutExpert: 'بدون کارشناس',
  answered: 'پاسخ داده شد',
  searchByPartnerName: 'جستجو بر اساس نام همکار فروش',
  partnerType: 'نوع همکار',
  internalAffiliat: 'داخلی',
  externalAffiliat: 'سازمانی',
  assignementType: 'نوع تخصیص',
  paymentPending: 'انتظار تأیید پرداخت',
  partiallyReturned: 'بخشی مرجوع شده',
  oldSoftwareMigration: 'وضعیت انتقال کاربران',
  totalActiveUsers: 'کل کاربران',
  totalMigratedUsers: 'کاربران منتقل شده',
  totalActiveUsersWithActiveTerms: 'کاربران فعال با دوره فعال',
  usersWithActiveTerms: 'کاربران با دوره فعال',
  usersWithoutActiveTerms: 'کاربران بدون دوره فعال',
  usersWithPayment: 'کاربران با حداقل یک پرداخت',
  migrateSelected: 'انتقال موارد انتخابی',
  hasPayment: 'دارای پرداخت',
  noPayment: 'بدون پرداخت',
  paymentStatus: 'وضعیت پرداخت',
  migrationStatus: 'وضعیت انتقال',
  migrated: 'منتقل شده',
  notMigrated: 'منتقل نشده',
  checkPoint: 'نقطه بررسی',
  includeDeleted: 'شامل حذف شده‌ها',
  termInfo: 'اطلاعات دوره',
  conditionInfo: 'اطلاعات شرایط',
  startedAt: 'تاریخ شروع',
  expiredAt: 'تاریخ پایان',
  extraDays: 'روزهای اضافی',
  isStopped: 'متوقف شده',
  userDetails: 'جزئیات کاربر',
  oldSoftwareUsers: 'کاربران نرم‌افزار قدیم',
  noTerms: 'دوره‌ای ثبت نشده',
  noCondition: 'شرایطی ثبت نشده',
  migrationSuccess: 'کاربر با موفقیت منتقل شد',
  migrationFailed: 'خطا در انتقال کاربر',
  migrateUser: 'انتقال کاربر',
  proceedAnyway: 'ادامه انتقال',
  forceMigrateConfirmCancel: 'انصراف',
  oldPanel: 'پنل قدیم',
  newPanel: 'پنل جدید',
  vipUsers: 'کاربران VIP',
  migrationInProgress: 'در حال انتقال کاربران...',
  migratedCount: '{count} از {total} کاربر منتقل شد',
  errorsCount: '{count} خطا',
  migrationErrors: 'خطاهای انتقال',
  clearErrors: 'پاک کردن',
  andMoreErrors: 'و {count} خطای دیگر...',
  migrateAll: 'انتقال همه',
  fetchUserIdsFailed: 'خطا در دریافت لیست کاربران',
  batchMigrationComplete: '{count} کاربر با موفقیت منتقل شدند',
  migrationLog: 'گزارش انتقال',
  successCount: 'موفق',
  errorCount: 'خطا',
  stopMigration: 'توقف',
  clearLog: 'پاک کردن',
  migratingUser: 'در حال انتقال کاربر {id}...',
  waitingForResults: 'در انتظار نتایج...',
  activeTerm: 'دوره فعال',
  hasActiveTerm: 'دارای دوره فعال',
  noActiveTerm: 'بدون دوره فعال',
  vipStatus: 'وضعیت VIP',
  isVip: 'کاربر VIP',
  notVip: 'غیر VIP',
  alternativeTitle: 'عنوان جایگزین',
  activateFasting: 'فعال کردن فستینگ',
  defaultFasting: 'پیشفرض فستینگ',
  priceType: 'نوع قیمت',
  price: 'قیمت',
  specialPrice: 'قیمت ویژه',
  specialDiscountDescription: 'توضیحات قیمت ویژه',
  commissionBasePrice: 'قیمت پایه کمیسیون',
  strategies: 'استراتژی‌ها',
  distributionStrategies: 'استراتژی‌های توزیع',
  dragOrSelectUsersHere: 'کاربران را اینجا بکشید یا انتخاب کنید',
  distributionList: 'لیست توزیع',
  lastAssignedUser: 'آخرین کاربر اضافه شده',
  strategy: 'استراتژی',
  assignedCount: 'تعداد تخصیص',
  addRule: 'افزودن',
  selectTypeToView: 'برای نمایش نوع استراتژی رو انتخاب کن',
  selectStrategyType: 'انتخاب نوع استراتژی',
  font: 'فونت',
  fontIranSanse: 'Iran Sanse',
  fontIranYekan: 'Iran Yekan',
  fontNegaar: 'Negaar',
  settlementStatus: 'وضعیت تسویه حساب',
  systemicLeads: 'لیدهای سیستمی',
  incompleteRegistration: 'ثبت نام ناقصی',
  nonRenewal: 'عدم تمدید',
  incompleteRegistrationIncomplete_payment: 'ثبت نام ناقصی + پرداخت ناقص',
  nonRenewalIncompletePayment: 'عدم تمدید + پرداخت ناقص',
  userState: 'وضعیت کاربر',
  PaymentDate: 'تاریخ پرداخت',
  totalNumber: 'تعداد کل',
  haveSalesExpert: 'کارشناس فروش داشته باشد',
  sharedOrder: 'سفارش مشترک',
  hasFastPro: 'فست پرو',
  orderRequest: 'سفارش',
  orderStatus: 'وضعیت سفارش',
  commandRequestCommand: 'درخواست',
  commandRequestSource: 'مبدأ',
  system: 'سیستم',
  allocationRule: 'درگاه هوشمند',
  addAllocationRule: 'افزودن درگاه هوشمند جدید',
  editAllocationRule: 'ویرایش قانون تخصیص',
  allocationRuleDetail: 'جزئیات قانون تخصیص',
  allocationRuleDeleteConfirm: 'آیا مطمئن هستید که می‌خواهید این درگاه هوشمند را غیرفعال کنید؟',
  allocationRuleArchiveTitle: 'بایگانی درگاه هوشمند',
  allocationRuleArchiveConfirm: 'آیا مطمئن هستید که می‌خواهید این درگاه هوشمند را بایگانی کنید؟',
  allocationRuleResetCycleConfirm: 'با فعال‌سازی این درگاه هوشمند، درگاه هوشمند فعال فعلی غیرفعال خواهد شد. آیا مطمئن هستید؟',
  allocationMode: 'حالت توزیع درآمد',
  visibilityMode: 'حالت نمایش',
  allocationFiltered: 'فیلتر شده',
  allocationSuggested: 'پیشنهادی',
  allocationPercentage: 'درصد تخصیص',
  mustBe100: 'مجموع درصدها باید ۱۰۰٪ باشد',
  periodDays: 'دوره (روز)',
  ruleAccounts: 'حساب‌های قانون',
  activeCycle: 'سیکل فعال',
  paymentAccountId: 'شناسه حساب پرداخت',
  targetPercentage: 'درصد هدف',
  maxAllocationAmount: 'حداکثر مبلغ تخصیص',
  accountsCount: 'تعداد درگاه‌ها',
  activatedAt: 'تاریخ فعال‌سازی',
  percentageBased: 'درصدی',
  allocationFixedAmount: 'مبلغ ثابت',
  allocationDraft: 'پیش‌نویس',
  allocationArchived: 'بایگانی',
  allocationArchive: 'بایگانی',
  resetCycle: 'ریست سیکل',
  resetCycleConfirm: 'آیا از ریست سیکل فعال اطمینان دارید؟',
  addAccount: 'افزودن حساب',
  addGateway: 'افزودن درگاه',
  allocationConfiguration: 'پیکربندی تخصیص',
  allocationProgress: 'پیشرفت',
  allocationAllocated: 'تخصیص یافته',
  allocationTarget: 'هدف',
  days: 'روز',

  generalSettings: 'تنظیمات کلی',
  filtered: 'فیلتر شده',
  filteredDescription: 'نمایش فقط درگاه های تعریف شده به کاربران',
  suggested: 'پیشنهادی',
  suggestedDescription: 'نمایش درگاه به صورت انتخاب شده به کاربران',
  percentageBasedDescription: 'درصدی از درآمد به صورت خودکار به هر حساب اختصاص داده می‌شود',
  fixedAmountDescription: 'حداکثر مبلغ ثابتی به هر درگاه در طول هر سیکل اختصاص داده می‌شود',
  numberOfAccounts: 'تعداد درگاه‌ها',
  totalPercentage: 'مجموع درصدها',
  remaining: 'باقی‌مانده',
  mustEqual100: 'مجموع درصدها باید دقیقاً ۱۰۰٪ باشد',
  allocationComplete: 'تخصیص کامل است',
  allocationReadyToSave: 'می‌توانید قانون را ذخیره کنید',
  exceeded: 'بیش از حد مجاز',
  ruleNotFound: 'قانون تخصیص یافت نشد یا دسترسی ندارید',
  remove: 'حذف',
  paymentGateway: 'درگاه پرداخت',
  calorieFormulas: 'فرمول‌های کالری',
  addCalorieFormula: 'افزودن فرمول کالری',
  editCalorieFormula: 'ویرایش فرمول کالری',
  calorieFormula: 'فرمول کالری',
  systemDefaultLeaveEmpty: 'پیش‌فرض سیستم (خالی بگذارید)',
  isDefaultFormula: 'فرمول پیش‌فرض',
  variants: 'فرمول‌ها',
  variant: 'فرمول',
  add: 'افزودن',
  ageMin: 'حداقل سن',
  ageMax: 'حداکثر سن',
  heightUnit: 'واحد قد',
  centimeter: 'سانتی‌متر',
  meter: 'متر',
  formulaTerms: 'عبارت‌های فرمول',
  formulaPreview: 'فرمول',
  variable: 'متغیر',
  constant: 'عدد ثابت',
  scaledByActivity: 'ضرب در ضریب فعالیت',
  activityLevels: 'ضرایب فعالیت',
  deductionOptions: 'تنظیمات کاهش/افزایش کالری',
  delta: 'مقدار کسر/افزایش (کالری)',
  adjustmentRatio: 'ضریب تعدیل',
  increase: 'افزایش',
  decrease: 'کاهش',
  percentEffect: '{direction} {percent} درصد',
  kcalEffect: '{direction} {amount} کالری',
  noEffect: 'بدون تغییر',
  deductionRuleSummary: 'اگر {condition}: {effect}',
  eligibility: 'شرایط اعمال',
  bmi: 'BMI',
  label: 'برچسب',
  noVariantsYet: 'هنوز فرمولی اضافه نشده است.',
  noTermsYet: 'هنوز عبارتی اضافه نشده است.',
  legacyFormulaImmutable: 'این فرمول پیش‌فرض داخلی سیستم است و قابل ویرایش یا حذف نیست.',
  anyDietType: 'بدون تفکیک نوع رژیم',
  baseCalorie: 'کالری پایه (TDEE)',
  goalBmiDiffSmall: 'فاصله‌ی BMI تا هدف کم است',
  activityOption: 'سطح فعالیت',
  selectActivityOption: 'یک سطح فعالیت از فهرست انتخاب کنید',
  lessThan: 'کمتر از',
  lessThanOrEqual: 'کمتر یا مساوی',
  greaterThan: 'بیشتر از',
  greaterThanOrEqual: 'بیشتر یا مساوی',
  equalTo: 'برابر با',
  from: 'از',
  to: 'تا',
  unlimitedAge: 'بدون محدودیت سنی',
  noConditions: 'بدون شرط (همیشه فعال)',
  noActivityLevelsDefined: 'بدون ضریب فعالیت (ضریب ۱ در نظر گرفته می‌شود)',
  viewCalorieFormula: 'نمایش فرمول کالری',
  and: 'و',
  atLeast: 'حداقل',
  searchVariants: 'جستجو در فرمول‌ها...',
  moveUp: 'جابجایی به بالا',
  moveDown: 'جابجایی به پایین',
  expandVariantToPreview: 'یک فرمول را باز کنید تا پیش‌نمایش نمایش داده شود.',
  sampleCalculation: 'ماشین حساب فرمول',
  result: 'نتیجه',
  caloriesPerDay: 'کالری در روز',
  appliedOption: 'گزینه‌ی اعمال‌شده',
  activityLevel: 'سطح فعالیت',
  selectActivityOptionWarning: 'یک سطح فعالیت انتخاب کنید',
  conditionCount: '{n} شرط',
  transcribe: 'متن‌نویسی',
  transcript: 'متن ایجاد شد',
  transcriptionPending: 'در حال تبدیل صوت به متن...',
  transcriptionFailed: 'تبدیل صوت به متن ناموفق بود',
  editTranscript: 'ویرایش متن',
  saveTranscript: 'ذخیره متن',
  retry: 'تلاش مجدد',
  correctedTranscript: 'متن تصحیح‌شده',
  originalTranscript: 'متن اصلی',
  correctedAt: 'تصحیح‌شده در',
  viewOriginal: 'مشاهده متن اصلی',
  viewCorrected: 'مشاهده متن تصحیح‌شده',
  editingTranscript: 'در حال ویرایش متن',
  segmentsChanged: '{count} بخش ویرایش شد',
  changed: 'ویرایش شد',
  playSegment: 'پخش این بخش',
  noSegments: 'برای این متن، بخشی وجود ندارد.',
  playbackSpeed: 'سرعت پخش',
  downloadAudio: 'دانلود فایل صوتی',
  transferTerm: 'انتقال دوره',
  destinationUser: 'کاربر مقصد'
};

export default fa;
